import styles from './styles.scss'

export default `<div class="eplayer-time-to-ad eplayer-skin-fullsize eplayer-skin-shiftable eplayer-skin-component eplayer-holdable">
  <div class="${styles.timeToAdCounter}"><%= advertisement_starting_in %> <span>5</span></div>
</div>
`
